import analytics from "../analytics/analytics.js";
import { createBasketRequest } from "../graphQLRequest/createBasketRequest.js";
import { hotelRoomsOptionsManager } from "./HotelRoomsOptions/hotelRoomsOptionsManager.js";
const handleBookHotelClick = ({ hotelName, hotelId, args, checkIn, checkOut, submitMessages, isMobile, cguid, rguid, itemKey, priceKey, total, minCurrencyCode, minCurrencyCodeSymbol })=>function(event) {
        event.preventDefault();
        event.stopPropagation();
        analytics.log({
            label: 'HotelSearchResult',
            hotelId,
            message: 'HOTEL_CHECKOUT_LINK_CLICKED',
            ...args
        });
        if ((!checkIn || !checkOut || 'number' != typeof total) && submitMessages) return void submitMessages({
            role: 'user',
            content: `Book hotel ${hotelName}, id: ${hotelId}`
        });
        createBasketRequest({
            itemType: 'STAY',
            appc: isMobile ? 'MOBILEWEB' : 'DESKTOP',
            cguid,
            rguid,
            itemKey,
            priceKey,
            total,
            minCurrencyCode,
            minCurrencyCodeSymbol
        });
    };
const handleHotelRoomBookNowClick = ({ rateId, isMobile, cguid, rguid })=>function(event) {
        event.preventDefault();
        event.stopPropagation();
        const hotelRoom = hotelRoomsOptionsManager.getHotelRoomsByRateId(rateId);
        const { itemKey, priceKey, totalPrice, minCurrencyCode, minCurrencyCodeSymbol } = hotelRoom;
        if (hotelRoom) createBasketRequest({
            itemType: 'STAY',
            appc: isMobile ? 'MOBILEWEB' : 'DESKTOP',
            cguid,
            rguid,
            itemKey,
            priceKey,
            total: totalPrice?.amount,
            minCurrencyCode,
            minCurrencyCodeSymbol
        });
    };
export { handleBookHotelClick, handleHotelRoomBookNowClick };
